import React from 'react'
import PropTypes from "prop-types"
import moment from 'moment'
import { isEqual, isEmpty } from 'lodash'

import {
  Modal, Form, FormGroup, FormControl, ControlLabel, Checkbox, Panel, Col
} from 'react-bootstrap'

import Button from '../components/Button'
import CommutingForm from './components/CommutingForm'

import { getText } from '../lib/text'
import { Price, emptyPrice, PriceEditor } from '../components/Price'
import ActivityTime from "./ActivityDetail.Time"
import { checkDate } from "../timetable/timetable"

  
/**
 * #NOTE sobre itemInTemplate
 * if this activity-item is part of a template/block, it shouldn't heed
 * the frozenPrice at all.
 * frozenPrice is only used in routes that belong to a client.
 * I know, it's weird as fuck.
 */

const ActivityDetails = (props) => {
  const { item, i, routeId, onChange, onClose, title, Activities, itemInTemplate, startDate, daysCounter } = props
  const activity = Activities[item.id]
  const date =  moment(startDate).add(daysCounter - 1, "days")
  const tt = activity.timetable
  
  const isEmptyTT = isEmpty(tt.exceptions) && isEmpty(tt.schedules)

  return (
    <Modal show onHide={() => onClose()}>
      <Modal.Header>
        <Modal.Title>{title || "Detalles"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {
          (item.type == "activity" && !itemInTemplate && !isEqual(item.frozenPrice, activity.price)) && (
            <Panel>
              <Panel.Body>
                <p>{getText("activity_price_changed")}</p>
                <Price price={activity.price} label={getText("Precio actual")} />
                <Price price={item.frozenPrice} label={getText("Precio cuando se añadio a la ruta")} />

                {
                  item.useCustomPrice && (
                    <Price price={item.customPrice} label={getText("Precio personalizado")} />
                  )
                }

                <Button
                  glyph="refresh"
                  onClick={() => {
                    onChange( routeId,  i, "frozenPrice", activity.price)
                    onChange( routeId,  i, "useCustomPrice", false)
                  }}
                >
                  Actualizar al precio actual
                </Button>
              </Panel.Body>
            </Panel>
          )
        }

        <Form inline style={{ marginTop: 15 }}>
          <ActivityTime 
            activity={activity}
            date={date}
            item={item}
            onChange={itemTime => onChange( routeId,  i, "time", itemTime)}
          />

          <Checkbox
            style={{ marginTop: 15, display: "block" }}
            checked={!!item.useCustomFee}
            onChange={evt => onChange( routeId,  i, "useCustomFee", evt.target.checked)}
          >
            {`  ${getText("Cambiar gastos de gestión (sólo para este ítem)")}`}
          </Checkbox>

          {
            item.useCustomFee && (
              <FormGroup style={{ display: "block" }}>
                <ControlLabel>{getText("Nuevo % gestión")}</ControlLabel>
                <FormControl
                  style={{ marginLeft: 10 }}
                  type="number"
                  value={item.customFee || 0}
                  onChange={evt => onChange( routeId,  i, "customFee", parseInt(evt.target.value))}
                />
              </FormGroup>
            )
          }

          <Checkbox
            style={{ marginTop: 15 }}
            checked={!!item.useCustomPrice}
            onChange={evt => { onChange( routeId,  i, "useCustomPrice", evt.target.checked); onChange( routeId,  i, "customPrice", item.customPrice || emptyPrice) }}
          >
            {`  ${getText("Cambiar precio (sólo para esta vez)")}`}
          </Checkbox>
        </Form>

        {
          item.useCustomPrice && (
            <PriceEditor
              price={item.customPrice || emptyPrice}
              onChange={v => onChange( routeId,  i, "customPrice", v)}
              disabled={!item.useCustomPrice}
            />
          )
        }

        <CommutingForm
          item={item}
          onChange={(k, v) => onChange( routeId,  i, k, v)}
          style={{ width: "50%", marginTop: 16 }}
        />

      </Modal.Body>
      <Modal.Footer>
        <Button bsStyle="success" onClick={() => onClose()} glyph="ok" label="OK" />
      </Modal.Footer>
    </Modal>
  )
}

ActivityDetails.propTypes = {
  item: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired, // (string, any) => void
  onClose: PropTypes.func.isRequired, // () => void
  activities: PropTypes.object.isRequired,
  itemInTemplate: PropTypes.boolean,
}

ActivityDetails.defaultProps = {
  itemInTemplate: false
}

export default ActivityDetails
